module.exports = __webpack_public_path__ + "4b8873d7829609aabd848dae6e056649.jpg";